import { Grid } from "@mui/material";

import { IndexesGosrCommentsItem } from "./IndexesGosrCommentsItem";
import styles from "./IndexesGosrCommentsModal.module.css";

export const IndexesGosrCommentsList = ({ comments }) => {
	return (
		<>
			{comments.length > 0 ? (
				<Grid container className={styles.container}>
					{comments.map((comment) => (
						<IndexesGosrCommentsItem key={comment[0]} comment={comment} />
					))}
				</Grid>
			) : (
				<div className={styles.emptyComments}>Примечание отсутствует</div>
			)}
		</>
	);
};
